export default "__VITE_ASSET__Cd9wvCNm__"